import React from 'react';
import { Typography } from 'antd';
import type { ScopedTaskPresentation } from '../../domain/scopedTaskPresentation';

const { Text } = Typography;

export function ScopedTaskPresentationLines({
  presentation,
  titleStrong = true,
  fontSize = 12,
  ellipsisTooltip,
}: {
  presentation: ScopedTaskPresentation;
  titleStrong?: boolean;
  fontSize?: number;
  ellipsisTooltip?: boolean;
}) {
  const showEllipsisTooltip = Boolean(ellipsisTooltip);
  const tooltip = presentation.tooltip;

  if (presentation.mode === 'scoped') {
    return (
      <>
        {presentation.lines.map((line, index) => {
          const isTitle = line === presentation.titleLine;
          return (
            <Text
              key={`${line}-${index}`}
              strong={titleStrong && isTitle}
              style={{ fontSize, display: 'block', lineHeight: `${fontSize + 8}px` }}
              ellipsis={showEllipsisTooltip ? { tooltip } : undefined}
            >
              {line}
            </Text>
          );
        })}
      </>
    );
  }

  return (
    <>
      <Text
        strong={titleStrong}
        style={{ fontSize: titleStrong ? fontSize + 1 : fontSize, display: 'block', lineHeight: `${fontSize + 8}px` }}
        ellipsis={showEllipsisTooltip ? { tooltip: presentation.legacyPrimaryLine } : undefined}
      >
        {presentation.legacyPrimaryLine}
      </Text>
      <Text
        type="secondary"
        style={{ fontSize: fontSize - 1, display: 'block', lineHeight: `${fontSize + 6}px`, marginTop: 2 }}
        ellipsis={showEllipsisTooltip ? { tooltip: presentation.legacySecondaryLine } : undefined}
      >
        {presentation.legacySecondaryLine}
      </Text>
    </>
  );
}
